import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Check, X } from "lucide-react";
import { PageTitle, Panel, Field, TextInput, Select, TextArea, Btn } from "../components/ui";
import { useI18n } from "../i18n";
import { CL } from "../api";

const STATUS = ["Taslak", "İç Kontrol", "Bağımsız Doğrulama", "Tamamlandı"];
const STDS = ["ISO 14064-3", "ISAE 3000", "ISO 14065"];
const OPINIONS = ["", "Makul Güvence", "Sınırlı Güvence"];

export default function Verification() {
  const { t } = useI18n();
  const [d, setD] = useState(null);
  const [saving, setSaving] = useState(false);
  useEffect(() => { CL.getVerification().then(setD).catch(() => {}); }, []);
  if (!d) return null;
  const up = (k) => (e) => { const v = e.target.value; setD((p) => ({ ...p, [k]: v })); };

  const save = async () => {
    setSaving(true);
    try {
      const saved = await CL.putVerification({
        status: d.status || "Taslak", verifier_name: d.verifier_name || "", standard: d.standard || "ISO 14064-3",
        verification_date: d.verification_date || "", opinion: d.opinion || "", note: d.note || "",
      });
      setD((p) => ({ ...p, ...saved })); toast.success(t("saved"));
    } catch { toast.error("Error"); } finally { setSaving(false); }
  };

  const ck = d.checklist || {};
  const items = [["has_entity", t("entity")], ["has_facilities", t("facilities")], ["has_activities", "Aktivite"], ["has_targets", t("targets")]];

  return (
    <div data-testid="verification-page">
      <PageTitle title={t("verificationTitle")} subtitle={t("verificationDesc")} />
      <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
        <Panel className="lg:col-span-2">
          <div className="grid grid-cols-2 gap-5">
            <Field label={t("status")}><Select data-testid="ver-status" value={d.status || "Taslak"} onChange={up("status")}>{STATUS.map((s) => <option key={s}>{s}</option>)}</Select></Field>
            <Field label={t("standard")}><Select data-testid="ver-standard" value={d.standard || "ISO 14064-3"} onChange={up("standard")}>{STDS.map((s) => <option key={s}>{s}</option>)}</Select></Field>
            <Field label={t("verifier")}><TextInput data-testid="ver-name" value={d.verifier_name || ""} onChange={up("verifier_name")} /></Field>
            <Field label={t("verificationDate")}><TextInput type="date" data-testid="ver-date" value={d.verification_date || ""} onChange={up("verification_date")} /></Field>
            <Field label={t("opinion")}><Select data-testid="ver-opinion" value={d.opinion || ""} onChange={up("opinion")}>{OPINIONS.map((s) => <option key={s} value={s}>{s || "—"}</option>)}</Select></Field>
          </div>
          <div className="mt-4"><Field label={t("note")}><TextArea data-testid="ver-note" value={d.note || ""} onChange={up("note")} /></Field></div>
          <div className="mt-6"><Btn onClick={save} disabled={saving} data-testid="ver-save">{saving ? "..." : t("save")}</Btn></div>
        </Panel>
        <Panel>
          <h3 className="mb-4 font-display text-lg text-[#16321f]">{t("readiness")}</h3>
          <ul className="space-y-3">
            {items.map(([k, label]) => (
              <li key={k} className="flex items-center gap-3 text-sm">
                <span className={`grid h-6 w-6 place-items-center rounded-full ${ck[k] ? "bg-[#14512f] text-white" : "bg-[#f0d9d6] text-[#b4342a]"}`}>
                  {ck[k] ? <Check className="h-3.5 w-3.5" /> : <X className="h-3.5 w-3.5" />}
                </span>
                <span className="text-[#3a423b]">{label}</span>
              </li>
            ))}
          </ul>
        </Panel>
      </div>
    </div>
  );
}
